__turbopack_context__.v({
  "wrapper": "ArticleModuleText-module-scss-module__RqtLyq__wrapper",
});
